import React from "react";
import "../styles/ClaimResult.css";

const RadarTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const score = payload.find(p => p.name === "AI Confidence")?.value;

    const explanations = {
      "Speech Clarity": "How clearly the person articulated their stance.",
      "Language Strength": "How strong or assertive the language was.",
      "Context Match": "How well the speech aligns with the claim.",
      "Vote Consistency": "Whether their votes align with the speech message.",
      "Speech Alignment": "Whether the speech tone supports or opposes the claim."
    };

    return (
      <div className="radar-tooltip">
        <strong>{label}</strong>
        <p>AI Confidence: <span>{score}</span></p>
        <p className="tooltip-explanation">{explanations[label]}</p>
      </div>
    );
  }

  return null;
};

export default RadarTooltip;
